// this just lets us have a hook in which we can change React built-ins used
// elsewhere
export * from 'react';
import React from 'react';
export default React;

export function propTypes (propTypeDeclarations) {
  return Component => {
    Component.propTypes = {
      ...propTypeDeclarations,
      ...(Component.propTypes || {}),
    };
    return Component;
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-react.js